import { takeEvery, fork, put, all } from 'redux-saga/effects';
// redux actions
import { setSmeReport } from './actions';
import { GET_REPORT } from './actionTypes';
// Api methods
import { api } from 'api';
// interface
import { AxiosResponse } from 'axios';
import { apiLoading, apiResError, apiResInfo, apiResSuccess } from '../actions';
import { OfferSearch, SMEReport } from 'api';

export interface IReportPayload {
	payload?: OfferSearch;
	type: string;
}

function* fetchReport({ payload }: IReportPayload) {
	yield put(apiLoading());
	console.log('SAGA|fetchSmeReport', payload);
	try {
		const response: AxiosResponse<SMEReport[]> =
			yield api.reports.apiReportSMEReportPost(payload);
		yield put(setSmeReport(response.data));
		if (response.data.length > 0) {
			yield put(apiResSuccess('Report fetched'));
		} else {
			yield put(apiResInfo('No records found'));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

export function* watchFetchReport() {
	yield takeEvery(GET_REPORT, fetchReport);
}

function* reportSaga() {
	yield all([fork(watchFetchReport)]);
}

export default reportSaga;
